var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010024;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,8.8c0.3,0,0.6,0.3,0.6,0.6V10h-1.2V9.4C10.6,9.1,10.8,8.8,11.2,8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,10.6V9.4h4.7V8.2H1.2V7.1h3.6V4.7h2.3V1.2h1.2v3.6h1.2V0h1.2v4.7h1.2V1.2h1.2v3.6h2.3v2.3H19v1.2h-3.6v1.2 H20v1.2h-4.7v1.2h3.6v1.2h-3.6v2.3H13V19h-1.2v-3.6h-1.2V20H9.4v-4.7H8.2v3.6H7.1v-3.6H4.7V13H1.2v-1.2h3.6v-1.2 C4.8,10.6,0,10.6,0,10.6z M7.1,7.7v4.7h1.2V7.7H7.1z M11.8,11.2v1.2H13v-3c0-1-0.8-1.8-1.8-1.8S9.4,8.4,9.4,9.4v2.9h1.2v-1.2h1.2 V11.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/icon-AI.7df04465d80fb86e671dcb4956ce59ec.svg";
export { ForwardRef as ReactComponent };